/** Montant en CHF arrondi au franc : 12'345 */
export function fmtCHF(n: number): string {
  return Math.round(n).toLocaleString('fr-CH');
}

/** Montant en CHF avec centimes quand ils existent : 5'382.90 */
export function fmtCHF2(n: number): string {
  const arrondi = Math.round(n * 100) / 100;
  return arrondi.toLocaleString('fr-CH', {
    minimumFractionDigits: Number.isInteger(arrondi) ? 0 : 2,
    maximumFractionDigits: 2,
  });
}

/** Taux d'occupation : 0.075 -> « 7.5 % » (espace avant % — typographie française) */
export function fmtPct(t: number): string {
  const v = Math.round(t * 1000) / 10;
  return `${Number.isInteger(v) ? v.toFixed(0) : v} %`;
}

/** '2026-07-01' -> « 07.2026 » ; '2026-07-15' -> « 15.07.2026 » */
export function fmtMoisFr(iso: string): string {
  const [y, m] = iso.split('-');
  return `${m}.${y}`;
}

export function fmtDateFr(iso: string | null): string {
  if (!iso) return '—';
  const [y, m, d] = iso.split('-');
  return `${d}.${m}.${y}`;
}
